import React from 'react'
import styles from './styles.css'
import Checkbox from 'App/components/fields/Checkbox'
import {Field} from 'simple-react-form'

export default class PayForm extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.pay}>
          {' '}
          <strong>Forma de pago 1° Mes</strong>
        </div>
        <div className="row center-md">
          <div className="col-xs-12 col-sm-2">
            Efectivo <Field fieldName="efectivo" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            Cheque <Field fieldName="cheque" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            OC <Field fieldName="oc" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            TC <Field fieldName="tc" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-3">
            Transferencia <Field fieldName="transferencia" type={Checkbox} />
          </div>
        </div>
        <br />
        <div className={styles.pay}>
          {' '}
          <strong>Forma de pago adicionales</strong>
        </div>
        <div className="row center-md">
          <div className="col-xs-12 col-sm-2">
            Efectivo <Field fieldName="efectivoAdicional" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            Cheque <Field fieldName="chequeAdicional" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            OC <Field fieldName="ocAdicional" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-2">
            TC <Field fieldName="tcAdicional" type={Checkbox} />
          </div>
          <div className="col-xs-12 col-sm-3">
            Transferencia <Field fieldName="transferenciaAdicional" type={Checkbox} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/PayForm/index.js